import IdGenerationService from '../IdGenerationService';

export default class BasicIdGenerationService implements IdGenerationService {
  generate(): string {
    return Math.floor(Math.random() * 1e9).toString(16);
  }
}
